import { Call, CallService } from "interfaces";

export class SorensonCallService implements CallService {
  calls = [];
  activeCall = undefined;

  call(uri: string): Promise<Call> {
    throw new Error("Method not implemented.");
  }
}
